import React from 'react';
import ErrorContent from './ErrorContent';

const Error404 = ({ message }) => (
    <ErrorContent error={'404'} message={message || 'This page could not be found'} />
)

export default Error404;
